import { createContext } from 'react';

const RecipeBookContext = createContext({
  books: [],
  selectedBookId: '',
  selectedBook: null,
  selectBook: () => {},
  isLoading: true,
  currentView: 'home',
  showAddMenu: false,
  setShowAddMenu: () => {},
  setShowSearchBar: () => {},
  viewingRecipe: null,
  closeRecipeDetail: () => {},
  openEditRecipe: () => {},
  deleteRecipe: () => {},
  shareRecipe: () => {},
  shareRecipeLink: () => {},
  isOwner: false,
  canEditRecipe: false,
  editingRecipe: null,
  saveEditRecipe: () => {},
  cancelEditRecipe: () => {},
  recipeBookId: null,
});

export default RecipeBookContext;